import { useDispatch, useSelector } from "react-redux"
import AllActivitiesMap from "../components/AllActivitiesMap"
import PageContainer from "../components/PageContainer"
import { useEffect, useState } from "react"
import { getUserMapActivities } from "../redux/userMapActivities"
import Loader from "../components/Loader"
import Pool from "../components/poolBar/Pool"
import CustomHr from "../components/CustomHr"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import { setWhichPage } from "../redux/searchbarSlice"
import error404 from '../static/images/404.jpg';

const MapPage = () => {
    const { t, i18n } = useTranslation();
    const { isLoading, error, data, activitiesAmount } = useSelector(state => state.userMapActivities)
    const { filtersObject } = useSelector(state => state.filters);

    // Eseguo la chiamata per ricere tutte le attività al montaggio del componente
    const dispatch = useDispatch();
    // Questo è lo useEffect che rieffettua le chiamate ogni volta che filtersObject cambia
    useEffect(() => {
        dispatch(getUserMapActivities({ filtersObject, lang: i18n.language }))
    }, [filtersObject, i18n.language])

    // Setto wichpage su 'MapPage'
    useEffect(() => {
        dispatch(setWhichPage('MapPage'))
    }, [])

    // Archivio tutte le coordinate delle attività ricevute
    const [markersData, setMarkersData] = useState(null)
    useEffect(() => {
        if (data) {
            let allActivities = [];
            data.forEach((element) => {
                let newObject = {};
                // Aggiungere qui dati da passare ai markers delle attività
                newObject.id = element._id;
                newObject.title = element.title;
                newObject.cover = element.coverImageUrl;
                newObject.lat = element.coordinates.lat;
                newObject.lng = element.coordinates.lng;
                newObject.activityType = element.activityType[0];
                newObject.category = element.category[0];
                newObject.roadLink = `https://www.google.com/maps/dir/?api=1&destination=${element.coordinates.lat},${element.coordinates.lng}`
                allActivities.push(newObject);
            })
            setMarkersData(allActivities);
        }
    }, [data])
    return (
        <PageContainer items="center">

            <Pool />

            {
                !isLoading && !error && data &&
                <div className="w-full text-center mt-8">
                    <div>
                        <h5><span className="text-[#225424]">{activitiesAmount}</span> {t('AllActivities.activitiesFound')}</h5>
                    </div>
                    <CustomHr />
                </div>
            }

            {/* ALL-ACTIVITIES BUTTON */}
            <Link to="/all-activities">
                <div className="flex gap-2 bg-[#225424] text-white py-2 px-4 rounded-xl cursor-pointer mt-4">
                    <i className="fi fi-rr-map mt-0.5"></i>
                    <div>{t('MapPage.listButton')}</div>
                </div>
            </Link>

            {!isLoading && !error && markersData && <AllActivitiesMap markersData={markersData} />}

            {
                /* 404 nessun elemento trovato */
                data && data.length === 0 &&
                <div className="mt-4 mx-16 flex flex-col xl:flex-row gap-8 justify-center items-center">
                    {/* Copy */}
                    <div className="flex flex-col items-center gap-4 text-center">
                        {/* <h3>Errore 404, nessun elemento trovato</h3> */}
                        <div className="text-8xl text-[#225424] font-signature mb-6">Coming Soon</div>
                        <div className="text-[#b05704] text-xl">Grandi avventure in arrivo!</div>
                    </div>

                    {/* Foto */}
                    <div className="rounded-xl overflow-hidden">
                        <img src={error404} alt="404" className="md:max-w-[800px]" />
                    </div>
                </div>

            }
            {
                error && error.message === "Nessuna attività trovata" &&
                <h3 className="mt-4 text-[#225424]">{t('AllActivities.noDataFoundError')}</h3>
            }
        </PageContainer>
    )
}

export default MapPage